import React from 'react';
import CheckboxInput from '../../atoms/Checkbox/Checkbox';

const Checkbox = ({ field, ...rest }: any) => (
  <CheckboxInput {...field} {...rest} />
);

export default Checkbox;
